import type { Translations } from '../../../types'

const shopMigrationsMessages: Translations = {
  "shop.migrations.messages.exportError": "Export catalogo fallito",
  "shop.migrations.messages.exportSuccess": "Export completato",
  "shop.migrations.messages.importFileRequired": "Seleziona un file zip",
  "shop.migrations.messages.importError": "Import catalogo fallito",
  "shop.migrations.messages.importSuccess": "Import completato",
  "shop.migrations.messages.importDryRunSuccess": "Dry-run completato"
}

export default shopMigrationsMessages
